import { render, staticRenderFns } from "./App.vue?vue&type=template&id=47717a5b&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mapengsheng/Documents/LEARN/WEBPACK/marain-build-webpack2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47717a5b')) {
      api.createRecord('47717a5b', component.options)
    } else {
      api.reload('47717a5b', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=47717a5b&", function () {
      api.rerender('47717a5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/card/App.vue"
export default component.exports